import { useEffect } from 'react';
import { useMatch, Outlet, useNavigate } from 'react-router-dom';
import { PermissionEnum, PermissionDenied, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import ROUTES from '../../routes';

import cn from './administration.module.css';

const getAdminsLink = (permission: PermissionEnum) => {
  let link;

  switch (permission) {
    case PermissionEnum.USERS_LIST:
      link = ROUTES.USER_LIST;
      break;
    case PermissionEnum.USERS_ROLES_LIST:
      link = ROUTES.USER_ROLES;
      break;
    case PermissionEnum.SETTINGS_SYSTEM_LIST:
      link = ROUTES.SETTINGS;
      break;
    case PermissionEnum.SECTION_CUSTOMERS:
      link = ROUTES.CLIENTS_LIST;
      break;
    case PermissionEnum.AUDIT_LOG_LIST:
      link = ROUTES.CHANGE_LOGS;
      break;
    case PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_LIST:
      link = ROUTES.NOTIFICATION_SETTINGS;
      break;
    case PermissionEnum.LOCKS_LIST:
      link = ROUTES.SECURITY;
      break;
    case PermissionEnum.ANONYMIZE_LOGS_LIST:
      link = ROUTES.ANONYMISATION;
      break;
    default:
      break;
  }

  return link as string;
};

const Administration = (): React.JSX.Element => {
  const navigate = useNavigate();

  const match = useMatch(ROUTES.ADMINISTRATION);
  const profileMatch = useMatch(ROUTES.SETTINGS_PROFILE);

  const { activePermissions } = useAppSelector(
    (state) => state.administrationDictionaries,
  );

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(PermissionEnum.SECTION_ADMINISTRATION)
    ) {
      const adminPages = [
        PermissionEnum.USERS_LIST,
        PermissionEnum.USERS_ROLES_LIST,
        PermissionEnum.SETTINGS_SYSTEM_LIST,
        PermissionEnum.SECTION_CUSTOMERS,
        PermissionEnum.AUDIT_LOG_LIST,
        PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_LIST,
        PermissionEnum.LOCKS_LIST,
        PermissionEnum.ANONYMIZE_LOGS_LIST,
      ];

      const activeAdminPages: PermissionEnum[] = [];

      adminPages.forEach((item) => {
        if (activePermissions.includes(item)) {
          activeAdminPages.push(item);
        }
      });

      if (activeAdminPages.length) {
        navigate(getAdminsLink(activeAdminPages[0]));
      } else {
        navigate('/');
      }
    }
  }, [match, activePermissions]);

  useEffect(() => {
    let title = 'Administration';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.administrationLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_ADMINISTRATION) &&
      !profileMatch
    ) {
      content = <PermissionDenied />;
    } else {
      content = <Outlet />;
    }
  }

  return content;
};

export default Administration;
